<template functional>
  <div>
    <span
      class="red cursor-pointer hover:text-red-800"
      :data-action="'showPayable'"
      :data-order-id="props.item.id"
    >
      {{ props.item.charges.payable | toCurrency }}
    </span>
  </div>
</template>

<script>
export default {
  name: "fltl-ap",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
